import { SimpleUser, User } from 'app/models';

export function userToSimplifiedUser(user: User): SimpleUser {
  return {
    id: user.id,
    username: user.username,
    gender: user.gender,
    avatar_url: user.avatar_url,
    is_followed: user.is_followed,
    is_contributor: user.is_contributor,
    activity_session_count: user.activity_sessions_count,
    followers_count: user.followers_count,
    birthdate: user.birthdate,
    country: user.country
  };
}
